import './Sidebar.scss'

function Sidebar({ id }: { id: string }) {
  return <div className="sidebar" id={id} />
}

export default Sidebar
